import { useCallback } from 'react';

import { getTranslation, getTranslatable } from '_i18n';

import type { BootcampEnrollment } from '../../enrollments/types';
import { getEnv } from '../../global/config/env';
import { useLocale } from '../../global/hooks/locale';
import { useSwitchEnrollment } from '../../enrollments/hook';
import { useSignedInUser } from '../../global/hooks/user';
import { DEFAULT_TRACK } from '../../enrollments/mappers';

export const useBootcampCardInfos = (enrollment: BootcampEnrollment) => {
    const { odysseyUrl } = getEnv();
    const locale = useLocale();
    const { user } = useSignedInUser();
    const { isLoading: loadingSwitchEnrollment, mutateAsync: switchEnrollment } = useSwitchEnrollment();

    const goToTraining = useCallback(async () => {
        // need to switch user current enrollment for odyssey if not the current enrollment
        if (!enrollment.isCurrent) {
            await switchEnrollment(enrollment.id);
        }
        window.location.href = odysseyUrl;
    }, [enrollment, odysseyUrl, switchEnrollment]);

    // disable access to avoid switching user to another bootcamp when masquerading
    const isAvailable = !user?.isMasquerading || enrollment.isCurrent;

    const name = getTranslation(enrollment.name, locale);
    const track = enrollment.track;

    return {
        ctaLabel: enrollment.type,
        goToTraining,
        isAvailable,
        name,
        loading: loadingSwitchEnrollment,
        color: track?.color ?? DEFAULT_TRACK.color,
        track: getTranslatable(track.name, locale),
        trainingType: enrollment.trainingType,
        droppedOutAt: enrollment.droppedOutAt,
    };
};
